import { Link } from "@components/Link/Link";
import React from "react";
import tw, { styled } from "twin.macro";

import { Image } from "../../Image/Image";
import { ImageWrapper } from "../../Styled/ImageWrapper";

const ItemImageWrapper = styled(ImageWrapper)`
  ${tw`bg-white relative w-full`}
`;

export const SearchResultsCalloutCard = (props) => {
  return (
    <div
      data-testid={"search-result-image-card"}
      style={{
        gridRow: `span ${props.callout.displayRows ?? 1}`,
        gridColumn: `span ${props.callout.displayColumns ?? 1}`,
      }}
    >
      <ItemImageWrapper className="group" image={props.callout.desktopImage}>
        <Link
          state={{ collection: props.collection }}
          to={props.callout.link}
          title={props.callout.title}
        >
          <Image
            alt={props.callout.title}
            image={props.callout.desktopImage}
            ratio="10/11"
            maxWidth={400}
          />
        </Link>
      </ItemImageWrapper>
    </div>
  );
};
